import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-41">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-glow from-whatsapp-glow via-transparent to-transparent opacity-50 pointer-events-none" data-id="element-42" />

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-44">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-6 leading-[1.1]" data-id="element-45">
            ¿Tu WhatsApp te está haciendo rico o te está{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500" data-id="element-46">
              robando la vida?
            </span>{' '}
            📱🔥
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-47">
            Automatiza tus ventas, elimina las quejas y recupera{' '}
            <span className="text-whatsapp font-bold" data-id="element-48">
              20 horas a la semana
            </span>{' '}
            con el Business-Rescue Kit 2026.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative max-w-2xl mx-auto mb-12" data-id="element-49">
          <div className="absolute inset-0 bg-whatsapp/20 blur-3xl rounded-full" data-id="element-50" />
          <img src="https://cdn.magicpatterns.com/uploads/iyCdyFxSDjXTEQ95KZFzQB/KIT_RESCUE_3.1.jpg" alt="Business Rescue Kit en un teléfono" className="relative z-10 w-full h-auto rounded-2xl border border-dark-border shadow-2xl" data-id="element-51" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-52">
          <CTAButton data-id="element-53" />
        </motion.div>
      </div>
    </section>;
}